export const LOGIN_API = '/api/security/login'
